import Riding from './Riding'
import Party from './Party'
import AbstractResult from './AbstractResult'
import PartyResultMap from './PartyResultMap'
import PartyResult from './PartyResult'

export default class RidingResult extends AbstractResult {
  protected _riding: Riding

  public get riding(): Riding {
    return this._riding
  }

  public constructor(partyResultMap: PartyResultMap, riding: Riding) {
    super()
    this._partyResultMap = partyResultMap
    this._riding = riding
    this.calculatePartyResults()
  }

  protected calculatePartyResults(): void {
    this._totalVoteCount = 0
    this._totalSeatCount = 1

    // const partyResultMap = new PartyResultMap()
    let highestVoteCount = 0
    let winnerParty: Party

    // First, update the total vote count and party vote count
    this._partyResultMap.results().forEach((partyResult): void => {
      const partyVoteCount = partyResult.voteCount
      this._totalVoteCount += partyVoteCount
      if (highestVoteCount < partyVoteCount) {
        highestVoteCount = partyVoteCount
        winnerParty = partyResult.party
      }
    })

    // Now fill in the seat count and vote/seat percents
    this._partyResultMap.results().forEach((partyResult): void => {
      partyResult.votePercent = partyResult.voteCount / this._totalVoteCount
      if (partyResult.party.key === winnerParty.key) {
        partyResult.seatCount = 1
        partyResult.seatPercent = 1.0
        partyResult.outcome = 'majority'
      }
    })

    // Done
    // this._partyResultMap = partyResultMap
  }

  public nthPlace(n: number): PartyResult {
    return this._partyResultMap.resultsByVotePercent()[n - 1]
  }

  public clone(): RidingResult {
    const clonedObject = new RidingResult(this.partyResultMap, this.riding)
    return clonedObject
  }

  public closeRace(): boolean {
    return this.margin() <= 0.05
  }

  public lowThreshold(): boolean {
    return this.winner().votePercent <= 0.35
  }
}
